import { SocialMediaBarItems } from "./SocialMedia";

export const SocialMediaContent: SocialMediaBarItems = {
	facebook: "https://www.facebook.com/ryersonmetals/?fref=nf",
	linkedIn: "https://www.linkedin.com/company/ryerson?trk=top_nav_home",
	email: "mailto:contactus@ryerson.com",
	youtube: "https://www.youtube.com/channel/UCAjLhGiGaSBbTOwq52rZNAw",
};
